// import { Link } from "react-router-dom";

import logo from "../assets/logo.png";
import { social } from "../constants/social";

const Navbar = () => {
  return (
    <nav
      className="navbar navbar-expand-lg navbar-dark fixed-top"
      data-aos="fade-up"
      data-aos-duration="700"
    >
      <div className="container">
        <div className="d-flex flex-grow-1">
          <a className="navbar-brand" href="/">
            <img src={logo} width="120px" alt="logo" />
          </a>
          <div className="hstack ms-auto">
            <button
              className="navbar-toggler"
              style={{
                margin: "auto",
                border: "none",
                background: "transparent",
                outline: "none",
                boxShadow: "none",
              }}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbar"
            >
              <span>
                <i className="bi bi-three-dots-vertical"></i>
              </span>
            </button>
          </div>
        </div>
        <div
          className="collapse navbar-collapse flex-grow-1 text-right"
          id="navbar"
        >
          <ul className="navbar-nav ms-auto flex-nowrap">
            <li className="nav-item">
              <a href="/#home" className="nav-link">
                Home
              </a>
            </li>
            <li className="nav-item">
              <a href="/#about" className="nav-link">
                About
              </a>
            </li>
            <li className="nav-item">
              <a href="/#team" className="nav-link">
                Team
              </a>
            </li>
            <li className="nav-item">
              <a href="/#faq" className="nav-link">
                FAQ
              </a>
            </li>
            {social.map((item, index) => (
              <li key={index} className="nav-item">
                <a
                  href={item.link}
                  className="nav-link"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  {item.icon}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
